import ModulePlanningClassResourceModel from '../../generated/types/model/resource/ModulePlanningClassResourceModel';

export default class ModulePlanningClassResourceViewModel extends ModulePlanningClassResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
